import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ESTILO_BOTON_LISTAR_ATRAS, ESTILO_BOTON_LISTAR_NUEVO, } from "../../../utils/const/estilos-const";
import ModalConfirmar from "../../../components/modal-confirmar";
import { useTranslation } from "react-i18next";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import sinAccesoCard from "../../../components/sin-acceso-card";
import { sharedNextPage } from "../../../utils/shared-functions";
import Select from "react-select";
import { SELECT_HABILITADO_DESHABILITADO } from "../../../utils/const/const-select-habilitado-deshabilitado";
import { disableEmpresa, enableEmpresa, obtenerListaEmpresaPlataforma } from "../../../api/api-empresa-plataforma";
import { INT_TRUE, INT_FALSE } from "../../../utils/const/int-const";
import moment from "moment";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

// import { ClientSideRowModelModule } from "ag-grid-community"; // Import required module
// import { GridOptions, ModuleRegistry } from "ag-grid-community"; // Registry for modules
//import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS
//import "ag-grid-community/styles/ag-theme-alpine.css"; // Theme CSS
import "../../../style/style-ag-grid.css";
import { COLOR_AZUL_MAIN, COLOR_VERDE } from "../../../utils/const/colors-const";
import { STRING_COLOR_PRIMARIO, STRING_COLUMN_NAME, } from "../../../utils/const/string-const";
import { obtenerEquiposActivosPorEmpresaPlataforma } from "../../../api/api-empresa";
import ModalRegistrarPago from "../../../components/registrar-pago-modal";
ModuleRegistry.registerModules([AllCommunityModule]);

// const idTipoUsuario = parseInt(localStorage.getItem("tipoUsuarioChecklist"));
let accesoBotonNuevo = '';


export default function ListCompany() {

  const history = useHistory();
  const { t } = useTranslation();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [rowData, setRowData] = useState([]);
  const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
  const [modalConfirmarHabilitarVisible, setModalConfirmarHabilitarVisible] = useState(false);
  const [elementoSelected, setElementoSelected] = useState(null);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(true);
  const [habilitadoSelected, setHabilitadoSelected] = useState(null);
  const statusOptions = SELECT_HABILITADO_DESHABILITADO.map(option => ({
    value: option.value,
    label: t(option.label), // Ensure it matches translation keys
  }));
  const [primaryColor, setPrimaryColor] = useState(COLOR_AZUL_MAIN);
  const [isHovered, setIsHovered] = useState(false);
  const hoverColor = COLOR_AZUL_MAIN;

  const [showModalRegistrarPago, setShowModalRegistrarPago] = useState(false);

  const columnDefs = [
    {
      field: "acciones", headerName: t("column_actions"), width: 400,
      cellRenderer: (params) => {
        // console.log('cellRenderer');
        // console.log(params);
        return (
          <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
            <button
              onClick={() => onClickBtnEdit(params.data)}
              style={{
                backgroundColor: "#1E90FF",
                color: "white",
                border: "none",
                padding: "5px 10px",
                cursor: "pointer",
                borderRadius: "5px",
              }}
            >
              {t("label_edit")}
            </button>
            {params.data.habilitado === INT_TRUE &&
              <button
                onClick={() => onClickBtnDisable(params.data)}
                style={{
                  backgroundColor: "#DC3545",
                  color: "white",
                  border: "none",
                  padding: "5px 10px",
                  cursor: "pointer",
                  borderRadius: "5px",
                }}
              >
                {t("label_disable")}
              </button>
            }
            {params.data.habilitado === INT_FALSE &&
              <button
                onClick={() => onClickBtnEnable(params.data)}
                style={{
                  backgroundColor: "#DC3545",
                  color: "white",
                  border: "none",
                  padding: "5px 10px",
                  cursor: "pointer",
                  borderRadius: "5px",
                }}
              >
                {t("label_enable")}
              </button>
            }
            <button
              onClick={() => onClickBtnUsuarios(params.data)}
              style={{
                backgroundColor: COLOR_VERDE,
                color: "white",
                border: "none",
                padding: "5px 10px",
                cursor: "pointer",
                borderRadius: "5px",
              }}
            >
              {t("label_usuarios")}
            </button>
            {/* <button
              onClick={() => onClickBtnRegistrarPago(params.data)}
              style={{
                backgroundColor: COLOR_NARANJA,
                color: "white",
                border: "none",
                padding: "5px 10px",
                cursor: "pointer",
                borderRadius: "5px",
              }}
            >
              {t("label_registrar_pago")}
            </button> */}
          </div>
        );
      }
    },
    { field: "id", headerName: "ID", hide: false, filter: true, },
    { field: "codigo", headerName: t("column_code"), filter: true, },
    { field: "nombre", headerName: t("column_name"), filter: true, },
    { field: "telefonoEmpresa", headerName: t("column_phone_company"), filter: true, },
    { field: "emailEmpresa", headerName: t("column_email_company"), filter: true, },
    { field: "representante", headerName: t("column_delegate"), filter: true, },
    { field: "telefonoRepresentante", headerName: t("column_telephone_delegate"), filter: true, },
    { field: "emailRepresentante", headerName: t("column_email_delegate"), filter: true, },
    { field: "habilitado", headerName: "HABILITADO", hide: true, filter: true, },
    { field: "habilitadolabel", headerName: t("column_enable"), filter: true, },
    { field: "timeZone", headerName: "TIME ZONE", filter: true, },
    { field: "equiposActivos", headerName: t("column_equipos_activos"), filter: true, },
    { field: "equiposDesinstalados", headerName: t("column_equipos_desinstalados"), filter: true, width: 280, },
    // { field: "totalCobro", headerName: t("column_total_cobro"), filter: true, },
    // { field: "moneda", headerName: t("column_moneda"), filter: true, },
    { field: "diaFacturacion", headerName: t("column_dia_facturacion"), filter: true, },
    { field: "fechamodificacion", headerName: t("column_date_modify"), filter: true },
  ];

  useEffect(() => {
    const mainColor = localStorage.getItem(STRING_COLOR_PRIMARIO);
    if (mainColor !== null) {
      setPrimaryColor(mainColor);
    }
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      let objEnviar = {};
      objEnviar.habilitado = habilitadoSelected !== null ? habilitadoSelected.value : null;
      objEnviar.fechaInicio = moment().startOf("month").format("YYYY-MM-DD");
      objEnviar.fechaFin = moment().endOf("month").format("YYYY-MM-DD");
      /*obj.idMenuPrimerNivel = INT_ID_MODULO_CHECKLIST;
      obj.idMenuSegundoNivel = INT_ID_SEGUNDO_NIVEL_ADMINISTRACION_CHECKLIST;
      obj.idMenuTercerNivel = INT_ID_TERCER_NIVEL_CHECKLIST_OPCIONES_RESPUESTA;
      let obtenerPermisos = await obtenerPermisosPorNivelUsuarioWeb(obj);
      let permiso = obtenerPermisos[0];
      setPermisos(permiso);
      */
      // let permiso = null;
      let lista = [];

      // setTieneAccesoAlModulo(true);
      lista = await obtenerListaEmpresaPlataforma(objEnviar, false, t);

      // agregarInfoExtra(lista, permiso);
      setRowData(lista);
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  };

  // const agregarInfoExtra = async (lista, permiso) => {
  //   try {
  //     // console.log('agregarInfoExtra');
  //     // console.log(lista);

  //     for (let i = 0; i < lista.length; i++) {
  //       const element = lista[i];
  //       const fechaInicio = moment().startOf("month").format("YYYY-MM-DD");
  //       const fechaFin = moment().endOf("month").format("YYYY-MM-DD");
  //       let objEnviar = {};
  //       objEnviar.idEmpresaPlataforma = element.id;
  //       objEnviar.fechaInicio = fechaInicio;
  //       objEnviar.fechaFin = fechaFin;
  //       const response = await obtenerEquiposActivosPorEmpresaPlataforma(objEnviar);
  //       // console.log('response', response);
  //       const equiposActivos = response.equiposActivos || 0;
  //       const equiposDesinstalados = response.equiposDesinstalados || 0;
  //       lista[i].equiposActivos = equiposActivos;
  //       lista[i].equiposDesinstalados = equiposDesinstalados;
  //       // if ((equiposActivos > 0 || equiposDesinstalados > 0) && isNaN(element.precioUnitarioVehiculo) === false) {
  //       //   const totalActivos = parseInt(equiposActivos) * element.precioUnitarioVehiculo;
  //       //   const totalDesactivados = parseInt(equiposDesinstalados) * element.precioUnitarioVehiculo;
  //       //   // console.log('totalCobro', totalCobro);
  //       //   const totalCobro = totalActivos + totalDesactivados;
  //       //   lista[i].totalCobro = totalCobro;
  //       // } else {
  //       //   lista[i].totalCobro = null;
  //       // }
  //     }
  //     setRowData(lista);
  //   } catch (err) {
  //     console.log('agregarInfoExtra err');
  //     console.log(err);
  //   }
  // };

  // const onClickBtnRegistrarPago = (params) => {
  //   try {
  //     console.log("onClickBtnRegistrarPago");
  //     console.log(params);
  //     setElementoSelected(params);
  //     setShowModalRegistrarPago(true);
  //   } catch (err) {
  //     console.log("onClickBtnRegistrarPago err");
  //     console.log(err);
  //   }
  // };

  const onClickBtnUsuarios = (params) => {
    try {
      // console.log("onClickBtnEdit");
      // console.log(params);
      if (params.acciones !== undefined) {
        delete params.acciones;
      }
      // return;
      let obj = {};
      let data = {};
      data.id = params.id;
      obj.titulo = t("title_edit_company");
      obj.params = data;
      // console.log('obj');
      // console.log(obj);
      sharedNextPage("usuario-empresa", obj, history);
    } catch (err) {
      console.log("onClickBtnUsuarios err");
      console.log(err);
    }
  };

  const onClickBtnEdit = (params) => {
    try {
      // console.log("onClickBtnEdit");
      // console.log(params);
      if (params.acciones !== undefined) {
        delete params.acciones;
      }
      // return;
      let obj = {};
      let data = {};
      data.id = params.id;
      data.codigo = params.codigo;
      data.nombre = params.nombre;
      data.telefonoEmpresa = params.telefonoEmpresa;
      data.emailEmpresa = params.emailEmpresa;
      data.representante = params.representante;
      data.telefonoRepresentante = params.telefonoRepresentante;
      data.emailRepresentante = params.emailRepresentante;
      data.timeZone = params.timeZone;

      // data.precioUnitarioVehiculo = params.precioUnitarioVehiculo;
      // data.idMoneda = params.idMoneda;
      // data.diasPeriodoPrueba = params.diasPeriodoPrueba;
      // data.fechaExpiracion = params.fechaExpiracion;
      // data.periodoPrueba = params.periodoPrueba;

      data.nombreEncargadoCobranza = params.nombreEncargadoCobranza;
      data.cargoCobranza = params.cargoCobranza;
      data.telefonoCobranza = params.telefonoCobranza;
      data.emailCobranza = params.emailCobranza;
      data.diaFacturacion = params.diaFacturacion;

      obj.titulo = t("title_edit_company");
      obj.params = data;
      // console.log('obj');
      // console.log(obj);
      sharedNextPage("editar-empresa-plataforma", obj, history);
    } catch (err) {
      console.log("onClickBtnEdit err");
      console.log(err);
    }
  };

  const onClickBtnDisable = async (data) => {
    try {
      // console.log("onClickBtnDisable");
      // console.log(data);
      setElementoSelected(data);
      setModalConfirmarDeshabilitarVisible(true);
    } catch (err) {
      console.log("onClickBtnDisable err");
      console.log(err);
    }
  };

  const onClickBtnEnable = async (data) => {
    try {
      // console.log("habilitarVehiculo");
      // console.log(data);
      setElementoSelected(data);
      setModalConfirmarHabilitarVisible(true);
    } catch (err) {
      console.log("onClickBtnEnable err");
      console.log(err);
    }
  };

  const handleAtrasClick = () => {
    history.goBack();
  };

  const reset = async () => {
    setCargandoPage(true);
    iniciar();
  };

  const handleModalDeshabilitarModal = async () => {
    setModalConfirmarDeshabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    if (elementoSelected.id !== 0) {
      const response = await disableEmpresa(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        alert('Se deshabilito correctamente');
        reset();
      }
      if (response.error === true) {
        alert('No se pudo deshabilitar');
      }
    }
  };

  const handleModalHabilitarModal = async () => {
    setModalConfirmarHabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    if (elementoSelected.id !== 0) {
      const response = await enableEmpresa(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        alert('Se habilito correctamente');
        reset();
      }
      if (response.error === true) {
        alert('No se pudo habilitar');
      }
    }
  };

  const handleNuevoClick = () => {
    try {
      // console.log('handleNuevoClick');
      let obj = {};
      let data = {};
      data.id = 0;
      data.codigo = "";
      data.nombre = "";
      data.telefonoEmpresa = "";
      data.emailEmpresa = "";
      data.representante = "";
      data.telefonoRepresentante = "";
      data.emailRepresentante = "";
      data.timeZone = "";
      data.usuario = "";
      data.password = "";
      data.confirmarPassword = "";
      obj.titulo = "NUEVA EMPRESA";
      obj.params = data;
      // console.log('obj');
      // console.log(obj);
      sharedNextPage("empresa-plataforma", obj, history);
    } catch (err) {
      console.log('handleNuevoClick err');
      console.log(err);
    }
  };

  const onCellClicked = (data) => {
    try {
      // console.log('onCellClicked', data);
      if (data.column?.colDef?.headerName === STRING_COLUMN_NAME.ACCIONES) {
        return;
      }
      if (data.column?.colDef?.headerName === STRING_COLUMN_NAME.EQUIPOS_ACTIVOS ||
        data.column?.colDef?.headerName === STRING_COLUMN_NAME.EQUIPOS_DESACTIVADOS) {
        const obj = {};
        obj.idEmpresaPlataforma = data.data.id;
        sharedNextPage("eventos-empresa-plataforma", obj, history);
      }
    } catch (err) {
      console.log('onCellClicked err', err);
    }
  };

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return sinAccesoCard();
      }
      return (
        <div className="p-4">
          <div className="flex justify-between">
            <label
              style={{
                // paddingLeft: 10,
                fontWeight: 'bold',
              }}
            >
              {t("title_manage_companies")}
            </label>
            <div className="flex justify-center">
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_NUEVO}
                onClick={() => { handleNuevoClick(); }}
                style={{
                  display: accesoBotonNuevo,
                }}
              >
                {t("label_new")}
              </button>
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_ATRAS}
                onClick={(handleAtrasClick)}
              >
                {t("label_back")}
              </button>
              {/* <button
                type="button"
                className={ESTILO_BOTON_LISTAR_ATRAS}
                onClick={handleAtrasClick}
              >
                <Settings />
              </button> */}
            </div>
          </div>
          <div className="flex justify-between">
            <div>
              <label
                className="block text-[#0F3457] font-semibold mb-2"
                htmlFor="habilitado"
              >
                {t("column_status")}
              </label>
              <Select
                options={statusOptions}
                isSearchable={true} // Boolean props should not be strings
                isClearable={true}
                value={habilitadoSelected}
                onChange={(event) => setHabilitadoSelected(event)}
                placeholder={t("label_select_status")}
                menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
              />
            </div>
            <div className="">
              <label className="block">&nbsp;</label>
              <button
                type="button"
                className={`text-white font-semibold py-2 px-4 rounded`}
                style={{
                  backgroundColor: isHovered ? hoverColor : primaryColor,
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onClick={() => reset()}
              >
                {t("label_search")}
              </button>
            </div>
          </div>
          <div
            className="ag-theme-alpine pt-4"
            style={{
              height: "512px",
              width: "100%",
              "--ag-header-background-color": `${primaryColor}`,
            }}
          >
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs}
              pagination={true}
              rowHeight={50}
              onCellClicked={onCellClicked}
            />
          </div>
          <ModalConfirmar
            isOpen={modalConfirmarDeshabilitarVisible}
            onCancel={() => { setModalConfirmarDeshabilitarVisible(false); }}
            onConfirm={handleModalDeshabilitarModal}
            message={t("alert_disable_company")}
          />
          <ModalConfirmar
            isOpen={modalConfirmarHabilitarVisible}
            onCancel={() => { setModalConfirmarHabilitarVisible(false); }}
            onConfirm={handleModalHabilitarModal}
            message={t("alert_enable_company")}
          />
          <ModalRegistrarPago
            isOpen={showModalRegistrarPago}
            obj={elementoSelected}
            onClose={() => { setShowModalRegistrarPago(false); }}
          />
        </div>
      );
    } catch (err) {
      console.log('ListarArea render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
